'use client';

import getService from '@/actions/services/getService';
import StudioPreview from '@/assets/svg/StudioPreview';
import { AspectRatio } from '@/components/ui/aspect-ratio';
import { cn } from '@/lib/utils';
import { StrapiImage } from '@/types/img';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { useEffect, useState } from 'react';

export default function Preview({ img }: { img: StrapiImage }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 640);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);
  return (
    // <div className='w-full overflow-hidden sm:min-h-[292px] relative !px-0'>
    //   <motion.div className={cn('w-full mx-auto cursor-pointer')}>
    //     <motion.div
    //       animate={{
    //         x: 0,
    //         y: 0,
    //       }}
    //       transition={{ type: 'tween', ease: 'backOut', duration: 0.5 }}
    //       className='cursor-pointer'
    //     >
    //       <Image
    //         src={`${process.env.NEXT_PUBLIC_BACKEND_URL}${img.url}`}
    //         width={img.width}
    //         height={img.height}
    //         className='w-full hidden sm:block h-[439px] object-cover'
    //         alt=''
    //         unoptimized
    //       />
    //       <div className='hidden md:block'>
    //         <AspectRatio
    //           ratio={7 / 6}
    //           className='object-cover sm:hidden cursor-pointer'
    //           style={{ zIndex: 1000 }}
    //         >
    //           <Image
    //             src={`${process.env.NEXT_PUBLIC_BACKEND_URL}${img.url}`}
    //             width={img.width}
    //             height={img.height}
    //             className='h-full object-cover'
    //             alt=''
    //             unoptimized
    //           />
    //         </AspectRatio>
    //       </div>
    //       <div className='sm:hidden md:hidden block'>
    //         <AspectRatio
    //           ratio={4 / 2}
    //           className='object-cover w-full sm:hidden cursor-pointer'
    //           style={{ zIndex: 1000 }}
    //         >
    //           <Image
    //             src={`${process.env.NEXT_PUBLIC_BACKEND_URL}${img.url}`}
    //             width={img.width}
    //             height={img.height}
    //             className='h-full object-cover'
    //             alt=''
    //             unoptimized
    //           />
    //         </AspectRatio>
    //       </div>
    //     </motion.div>
    //   </motion.div>
    // </div>
    <div className='w-screen overflow-hidden relative '>
      <motion.div className='w-full h-full'>
        <motion.div
          animate={{ x: 0, y: 0 }}
          transition={{ type: 'tween', ease: 'backOut', duration: 0.5 }}
          className='w-full h-full'
        >
          {!isMobile ? (
            <Image
              src={img.url}
              width={img.width}
              height={img.height}
              className='w-full h-full object-cover'
              alt=''
              unoptimized
              onContextMenu={(e) => e.preventDefault()}
            />
          ) : (
            <div
              className='relative w-full'
              style={{ paddingBottom: `${(img.height / img.width) * 100}%` }}
            >
              <Image
                src={img.url}
                alt=''
                fill
                className='object-contain'
                unoptimized
                onContextMenu={(e) => e.preventDefault()}
              />
            </div>
          )}
        </motion.div>
      </motion.div>
    </div>
  );
}